import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { usePaginatedQuery } from '@sorare/core/src/hooks/graphql/usePaginatedQuery';

import { UserList } from '#src/components/network/UserList/index.tsx';
import { UserNetwork } from '#src/components/network/UserNetwork/index.tsx';

import type {
  NetworkRecommendedQuery,
  NetworkRecommendedQueryVariables,
} from './__generated__/index.graphql.ts';

const NETWORK_RECOMMENDED_QUERY = gql`
  query NetworkRecommendedQuery($after: String) {
    currentUser {
      slug
      recommendedManagers(first: 18, after: $after) {
        pageInfo {
          endCursor
          hasNextPage
        }
        nodes {
          slug
          ...UserNetwork_user
        }
      }
    }
  }
  ${UserNetwork.fragments.user}
` as TypedDocumentNode<
  NetworkRecommendedQuery,
  NetworkRecommendedQueryVariables
>;

export const Recommended = () => {
  const { loading, data, loadMore } = usePaginatedQuery(
    NETWORK_RECOMMENDED_QUERY,
    {
      connection: 'UserConnection',
    }
  );

  const load = () => {
    loadMore(false, {
      after: data?.currentUser?.recommendedManagers.pageInfo.endCursor,
    });
  };

  return (
    <UserList
      users={data?.currentUser?.recommendedManagers.nodes || []}
      renderUser={u => <UserNetwork key={u.slug} user={u} />}
      loading={loading}
      loadMore={load}
      hasNextPage={
        data?.currentUser?.recommendedManagers.pageInfo.hasNextPage || false
      }
    />
  );
};
